<ng-form #stepForm="ngForm">
    <h3 class="h3">{{ 'Apply for a trade account' | translate }}</h3>

    <!-- info  -->
    <p class="m-t-5 p1 col-12">
        {{'To apply for a Trade Account with us, please complete the following application form. Please note the
        following criteria apply:' | translate}}
    </p>

    <ul class="p1 m-t-5 col-12">
        <li>{{'Have been trading for a minimum of 2 years' | translate}}</li>
        <li>{{'Not an online only business' | translate}}</li>
        <li>{{'Must have business rated premieses' | translate}}</li>
    </ul>

    <div class="p1 m-t-5 col-12">
        <p>{{"If you have any questions, please don't hesitate to" | translate}}</p>
        <a class="underline"
           [attr.href]="'mailto:sales@horsehealth.co.uk' | translate">{{'contact us' | translate}}</a>
    </div>

    <!-- email field (for all forms) -->
    <input-wrap class="w-12 m-t-5"
                [messages]="{validateEmailExists: ('A customer with the same email address already exists' | translate)}">
        <input class="input p-b-5-s p-t-7-s"
               type="email"
               name="email"
               required
               validatePattern="email"
               [validateEmailExists]="exists"
               autocomplete="email"
               sl-input="email"
               cy-loginMailInput
               [(ngModel)]="email"
               [ngModelOptions]="{ updateOn: 'blur' }"
               (keyup.enter)="emailInput.blur()"
               [muiInput]="'Email Address' | translate"
               #emailInput>
    </input-wrap>

    @switch (content?.useAlternativeVariant) {
    @case (true) {
    <p class="m-t"
       *iCms="'alternativeVariantMessage' of content; content: 'html'"></p>
    }
    @default {
    <div class="m-t-5 m-t-7-m m-t-7-s"
         [grid]="[1,1,2,2][app.client.sizeId]">
        <!-- first name -->
        <input-wrap>
            <input class="input p-b-5-s p-t-7-s"
                   type="text"
                   name="firstname"
                   required
                   autocomplete="given-name"
                   sl-input="firstname"
                   cy-registerFnameInput
                   [(ngModel)]="data.firstname"
                   [muiInput]="'First Name' | translate">
        </input-wrap>
        <!-- last name -->
        <input-wrap class="block m-t-3-m m-t-3-s">
            <input class="input p-b-5-s p-t-7-s"
                   type="text"
                   name="lastname"
                   required
                   autocomplete="family-name"
                   sl-input="lastname"
                   cy-registerLnameInput
                   [(ngModel)]="data.lastname"
                   [muiInput]="'Last Name' | translate">
        </input-wrap>
    </div>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s password-input">
        <input class="input p-b-5-s p-t-7-s"
               type="password"
               name="password"
               required
               [attr.placeholder]="'Password' | translate"
               reverse="true"
               [(ngModel)]="data.password"
               [muiInput]="'Password' | translate">
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s m-b password-input"
                [messages]="{validateEqual: ('Password and its confirmation do not match' | translate)}">
        <input class="input p-b-5-s p-t-7-s"
               type="password"
               name="confirmPassword"
               required
               [attr.placeholder]="'Password' | translate"
               [matchCheck]="'password'"
               [(ngModel)]="data.confirmPassword"
               [muiInput]="'Confirm Password' | translate">
    </input-wrap>
    <!--Phone-->
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s m-b"
                [messages]="{ required: ('Please enter telephone' | translate) }">
        <input class="input"
               type="text"
               name="telephone"
               validatePattern="telephone"
               inputmode="tel"
               required
               autocomplete="tel"
               cy-addressAddPhone
               [muiInput]="'Phone Number' | translate"
               [(ngModel)]="data.telephone">
    </input-wrap>
    <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden"
                [messages]="{ required: ('Please enter store name' | translate) }">
        <input class="input p-b-6-m p-b-5-s p-t-7-s"
               type="text"
               name="store_name"
               required
               sl-input="store_name"
               [(ngModel)]="data.store_name"
               [muiInput]="'Store Name' | translate">
    </input-wrap>
    }
    }

</ng-form>